import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  const fadeIn = useFadeIn();
  return <section className="py-20 px-4 bg-black text-white border-t-8 border-yellow-400" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-71">
          <ShieldCheckIcon className="w-24 h-24 text-yellow-400 mx-auto mb-6" data-id="element-72" />

          <h2 className="text-4xl md:text-5xl font-black text-white mb-8 uppercase tracking-wide" data-id="element-73">
            🔒 Garantía sin vueltas
          </h2>

          <div className="text-xl md:text-2xl text-gray-300 space-y-4 mb-12 max-w-2xl mx-auto font-medium" data-id="element-74">
            <p data-id="element-75">
              Estamos tan seguros de que este Programa te va a encantar, que si
              no es así, te devolvemos el 100% de tu dinero.
            </p>
            <p data-id="element-76">
              Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
              escribís y te hacemos el reembolso. Así de simple.
            </p>
            <p className="text-yellow-400 font-bold text-3xl mt-8" data-id="element-77">
              Sin preguntas. Sin letra chica.
            </p>
          </div>
        </div>
      </div>
    </section>;
}